import { useEffect, useState } from "react";
import * as signalR from "@microsoft/signalr";

let presenceConnection = null;

const useSignalRPresence = () => {
  const [unreadMessages, setUnreadMessages] = useState(0);

  const startPresenceHub = async () => {
    if (presenceConnection) {
      console.log("Presence hub already connected.");
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      console.warn("No token found — skipping SignalR presence start.");
      return;
    }

    try {
      presenceConnection = new signalR.HubConnectionBuilder()
        .withUrl(`${process.env.REACT_APP_URL}/hubs/presence`, {
          accessTokenFactory: () => token,
        })
        .withAutomaticReconnect([0, 2000, 5000, 10000])
        .configureLogging(signalR.LogLevel.Information)
        .build();

      // Event listeners
      presenceConnection.on("GetUnReadMessages", (unread) => {
        setUnreadMessages(unread || 0);
      });

      presenceConnection.on("UpdateMessageCount", (count) => {
        setUnreadMessages(count || 0);
      });

      // Handle connection close gracefully
      presenceConnection.onclose((error) => {
        console.warn("Presence Hub disconnected:", error?.message || error);
        presenceConnection = null;
      });

      await presenceConnection.start();
      console.log(" Presence Hub Connected");
    } catch (error) {
      console.error("🚨 Presence Hub Error:", error?.message || error);
      presenceConnection = null;
    }
  };

  const stopPresenceHub = async () => {
    if (presenceConnection) {
      try {
        await presenceConnection.stop();
        console.log(" Presence Hub Disconnected");
      } catch (error) {
        console.error("Error stopping Presence Hub:", error);
      } finally {
        presenceConnection = null;
      }
    }
  };

  // Auto-stop on unmount
  useEffect(() => {
    return () => {
      stopPresenceHub();
    };
  }, []);

  return { unreadMessages, startPresenceHub, stopPresenceHub };
};

export default useSignalRPresence;
